import ShiftEnum from "./../../../shared/ShiftEnum.js";
import vSelect from 'vue-select';
import { ValidationMessage, FormLabel } from "../../../shared/components";
import HolePopup from "./holePopup.vue";
import HoleSideView from "../../projects/components/holeSideView.vue";
import { ManipulateElement } from "@/app/shared/ManipulateElement.js";

export default {
  props: {
    deviationTests: {
      type: Array,
      default: () => { }
    },
    drillingEntries: {
      type: Array,
      default: () => { }
    },
    stagingDailyReportId: {
      type: Number
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    projectZones: {
      type: Array,
      default: () => { }
    },
    reportHoles: {
      type: Array,
      default: () => { }
    },
    projectId: {
      type: Number
    },
    addHoleToReportHoles: {
      type: Function,
      default: null
    }
  },
  components: {
    vSelect,
    ValidationMessage,
    FormLabel,
    HolePopup,
    HoleSideView
  },
  data() {
    return {
      innerId: 0,
      activeSideView: false,
      activeHolePrompt: false,
      showInactiveInstruments: false,
      innerTests: [],
      selectedEntry: null,
      shifts: ShiftEnum.definition,
      newHole: {} // Object for the sideview's v-model (not used directly)
    }
  },
  mounted()
  {
    this.innerTests = this.deviationTests;
    this.initTestsList();
  },
  watch: {
    deviationTests() {
      this.innerTests = this.deviationTests;
      this.initTestsList();
    },
    projectId() {
      this.initTestsList();
    },
    drillingEntries() {
      this.initTestsList();
    }
  },
  computed: {
    instruments() {
      if (this.showInactiveInstruments) {
        return this.$store.state.drilling.instruments;
      }
      return this.$store.state.drilling.instruments.filter(i => i.isActive);
    }
  },
  methods: {
    createTest() {
      this.innerId++;
      this.selectedEntry = {
        stagingDailyReportId: this.stagingDailyReportId,
        id: 0,
        holeNumber: '',
        holeId: null,
        shift: ShiftEnum.Day,
        depth: null,
        azimuth: null,
        instrumentName: '',
        instrumentId: null,
        inclination: null,
        magnetism: null,
        innerId: this.innerId
      };
      this.activeHolePrompt = true;
      setTimeout(() => {
        this.elmnt = new ManipulateElement(".vs-dialog", document.getElementsByClassName("vs-dialog-header")[0], document.getElementsByClassName("vs-dialog-cancel")[0]);
      }, 500);
    },
    editTestHole(item) {
      this.selectedEntry = item;
      this.activeHolePrompt = true;
      setTimeout(() => {
        this.elmnt = new ManipulateElement(".vs-dialog", document.getElementsByClassName("vs-dialog-header")[0], document.getElementsByClassName("vs-dialog-cancel")[0]);
      }, 500);
    },
    closeHolePrompt() {
      this.activeHolePrompt = false;
      this.selectedEntry = null;
    },
    submitHole(entry, selectedHole) {
      this.activeHolePrompt = false;
      const indexOfHole = this.reportHoles.findIndex(h => h.holeId === entry.holeId);
      if (indexOfHole === -1) this.addHoleToReportHoles(selectedHole);
      if (selectedHole) {
        // find other entries on the same hole number that wasn't mapped to an existing hole and update them
        const entriesOnSameHoleNumber = this.innerTests.filter(e => e.holeNumber === entry.holeNumber
          && e.innerId !== entry.innerId
          && e.holeId === 0);
        entriesOnSameHoleNumber.forEach(e => {
          e.holeNumber = selectedHole.code;
          e.holeId = selectedHole.holeId;
        });
        const existingEntry = this.innerTests.find(e => e.innerId === entry.innerId);
        entry.holeNumber = selectedHole.code;
        if (!existingEntry) {
          this.innerTests.push(entry);
        }
        else {
          const index = this.innerTests.indexOf(existingEntry);
          Object.assign(this.innerTests[index], entry);
        }
        this.updateTestMaxDepth();
      }
    },
    updateTestMaxDepth() {
      this.innerTests.forEach(element => {
        const selectedHole = this.reportHoles.find(h => h.code === element.holeNumber);
        if (selectedHole) {
          // look for the later entry for the same hole
          const data = this.drillingEntries.filter(e => e.holeNumber === element.holeNumber);
          if (data.length > 0) {
            const highestData = data.sort((a, b) => { return (a.to > b.to) ? -1 : 1 });
            element.maxDepth = highestData[0].to;
          } else {
            element.maxDepth = 0;
          }
        }
      });
      this.$refs.deviationTestsObserver.validate();
    },
    isShiftMissing(entry) {
      // shift 0 (Day) is falsy, so a truthiness test would report it as missing
      return !entry || entry.shift === null || entry.shift === undefined;
    },
    getTestDescription(entry) {
      if (entry) {
        // shift can be null on imported entries; getNameFor would render the raw i18n key
        return entry.holeNumber + " - " + (this.isShiftMissing(entry) ? '' : ShiftEnum.getNameFor(entry.shift));
      }
      return '';
    },
    deleteTest(test) {
      const index = this.innerTests.findIndex(_ => _.id === test.id && _.holeNumber === test.holeNumber && _.shift === test.shift && _.instrumentId === test.instrumentId);
      this.innerTests.splice(index, 1);
    },

    initTestsList() {
      if (!this.innerTests) return;
      this.innerTests.forEach((entry, idx) => {
        if (entry.holeId === null || entry.holeId === undefined) {
          const entryHole = this.reportHoles.find(h => h.code === entry.holeNumber);
          entry.holeId = entryHole === undefined ? null : entryHole.holeId;
        }
        entry.innerId = idx;
      });
      this.innerId = this.innerTests.length;
      this.updateTestMaxDepth();
    },
    validateDepth(tr) {
      const depth = parseInt(tr.depth);
      const maxDepth = parseInt(tr.maxDepth);
      if (isNaN(depth) || isNaN(maxDepth)) return true;
      return depth > maxDepth && !this.readOnly
    },
    openSideView(holePopupSelectedShift, updateSelectedEntry) {
      this.holePopupSelectedShift = holePopupSelectedShift;
      if (updateSelectedEntry) {
        this.newHole = {
          holeId: -1, // This is to signal the holeInserted method that it should update the selected entry
          code: this.selectedEntry.holeNumber
        }
      }
      else {
        this.newHole = {}; // Reset the sideview model
      }
      this.activeSideView = true;
    },

    closeSideView() {
      this.activeSideView = false;
    },

    // This is not used but somehow Vue 2 doesn't like it when it's removed
    // (either in the component's props or here)
    holeUpdated() {
    },

    holeInserted(hole) {
      // The -1 as the holeId is just to signal this method that it should update the selected entry
      // instead of creating a new one and appending it to the entries list
      const updateSelectedEntry = hole.holeId === -1;
      if (updateSelectedEntry) hole.holeId = 0;

      hole.projectId = this.projectId;
      this.$vs.loading();
      this.$store.dispatch("drilling/addHole", hole).then(() => {
        this.$notifySaveSuccess();
        this.closeSideView();

        if (updateSelectedEntry) {
          this.selectedEntry.holeId = hole.holeId;
          this.selectedEntry.holeNumber = hole.code;
          this.selectedEntry.shift = this.holePopupSelectedShift;
          return this.submitHole(this.selectedEntry, hole);
        }
        this.selectedEntry = {
          holeId: hole.holeId,
          holeNumber: hole.code,
          shift: this.holePopupSelectedShift
        }

      }).catch((error) => {
        this.$handleSaveError(error);
      }).finally(() => {
        this.$vs.loading.close();
      });
    }

  }
}
